/**
 * 使用@nuxtjs/router模块扩展默认的创建路由方法，实现从CMS配置自定义路由（链接）
 */
import Router from 'vue-router'
import axios from 'axios';
import { doMock } from './utils/mock';

// 扩展后的创建路由方法
export async function createRouter(ssrContext, createDefaultRouter, routerOptions, config, store) {
  const options = routerOptions ? routerOptions : createDefaultRouter(ssrContext, config).options

  return new Router({
    ...options,
    routes: await mergeCMSRoutes(options.routes, config, store)
  })
}

// 在默认路由基础上合并来自CMS的自定义栏目路由数据
async function mergeCMSRoutes(defaultRoutes, config, store) {
  // 模拟数据
  if(config.axios.isMock) {
    doMock(axios);
  }
  //console.log(defaultRoutes);
  let channelTree = null;
  try { 
    channelTree = await axios.get('/channel/channelTree.do?sid=483', {
      baseURL: config.axios.baseURL ?? config.axios.browserBaseURL
    });
  } catch(err) {
    console.log(err);
  }
  
  if(channelTree) {
    traverseChannelTree(channelTree.data);
  }
  // 递归遍历栏目树
  function traverseChannelTree(channelList) {
    if(!channelList || channelList.length == 0) {
      return;
    }
    for(let channel of channelList) {
      // 找到对应栏目模板的默认路由
      // TODO: 动态数据的路由对应
      // const matchedRoute = defaultRoutes.find(route => route.name && (route.name === channel.template));
      // if(matchedRoute) {
      //   // 将栏目路径和该默认路由对应的组件作为新路由项写入路由列表
      //   defaultRoutes.push({
      //     path: (channel.showPath.startsWith('/') ? '' : '/') + channel.showPath,
      //     component: matchedRoute.component
      //   });
      // }

      // 将所有栏目对应page模板加入路由列表
      const pageRoute = defaultRoutes.find(route => route.name && (route.name === 'page'));
      if(channel.showPath) {
        defaultRoutes.push({
          path: (channel.showPath.startsWith('/') ? '' : '/') + channel.showPath,
          meta: {
            channelId: channel.id,
            title: channel.name
          },
          component: pageRoute.component
        });
      }
      // 将关联栏目加入路由列表(新闻详情等)
      if(channel.pages && channel.pages.length > 0) {
        for(let page of channel.pages) {
          // if(page.showPath) {
          //   defaultRoutes.push({
          //     // TODO：先默认添加id参数，之后考虑后台直接返回路由模板
          //     path: (page.showPath.startsWith('/') ? '' : '/') + page.showPath + '/:id?',
          //     meta: {
          //       channelId: page.id,
          //       title: page.name
          //     },
          //     component: pageRoute.component
          //   });
          // }
          const matchedRoute = defaultRoutes.find(route => route.name && (route.name === page.template));
          if(matchedRoute) {
            // 将栏目路径和该默认路由对应的组件作为新路由项写入路由列表
            defaultRoutes.push({
              path: (page.showPath.startsWith('/') ? '' : '/') + page.showPath + '/:id?',
              component: matchedRoute.component
            });
          }
        }
      }
      traverseChannelTree(channel.child);
    }
  }
  // console.log(defaultRoutes);
  return defaultRoutes;
}